import { AnyAction } from '@reduxjs/toolkit';
import { GetSubjectsRoutine } from '~modules/Subject/redux-routines';
import { ISubjectsState } from '../interfaces';

export const initialState: ISubjectsState = {
  data: [],
  error: null,
  isFetching: false,
};

export const subjectsReducer = (
  state: ISubjectsState = initialState,
  action: AnyAction,
): ISubjectsState => {
  switch (action.type) {
    case GetSubjectsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case GetSubjectsRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }
    case GetSubjectsRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    default:
      return state;
  }
};
